export default {
    fullDateOptions: {
        year: 'numeric', 
        month: 'numeric', 
        day: 'numeric',
        minute: 'numeric',
        hour: 'numeric'
    },
    dateOptions: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    },
    timeOptions: {
        hour: 'numeric',
        minute: 'numeric',
    },
    fullTimeOptions: {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    }
}